import type {CustomerScanContext} from "../scan-model/CustomerScanContext.tsx";
import {scanVersions as baseScanVersions} from "../../../analysis-process/3-perform-scan/scan-operations/2-ScanVersions.tsx";
import type {ScanContext} from "../../../analysis-process/3-perform-scan/scan-model/ScanContext.tsx";

/**
 * Adapter function to call scanVersions with CustomerScanContext
 * Maps CustomerAnalysisOptions fields to AnalysisOptions fields expected by scanVersions
 */
export async function scanCustomerVersions(ctx: CustomerScanContext) {
    // Create an adapter context that maps customer options to analysis options format
    const adaptedContext: ScanContext = {
        ...ctx,
        sharedJobs: {}, // Not used by scanVersions
        options: {
            ...ctx.options,
            // Map selectedProjects to analyseProjects
            analyseProjects: ctx.options.selectedProjects,
            // Add missing fields that scanVersions doesn't actually use
            analyseSchedules: false,
            analyseSharedJobs: false,
            sharedJobRunner: ctx.options.jobDownloadRunner,
            analyseDrivers: false,
            analyseCredentials: false,
            analyseWebhooks: false,
            analyseApiProfiles: false,
            analyseOauthConnections: false,
            analysePasswords: false,
            analyseGit: false,
            analyseQueueConfig: false
        }
    }
    
    return await baseScanVersions(adaptedContext)
}
